import { Reveal } from "./Reveal";

const SIGNALS = [
  "Rozhodnutí odkládáš, dokud nezazní souhlas od okolí.",
  "Víš, co chtějí ostatní. Méně už víš, co chceš ty.",
  "Sebevědomí ti stoupá a klesá podle reakcí druhých.",
  "Disciplína vydrží pár dní. Pak znovu ustoupí pohodlí.",
  "Ve vztazích opakuješ podobné situace a nevíš proč.",
  "Konflikt buď uhladíš, nebo vybuchne. Málokdy vyřeší.",
  "U žen se snažíš příliš — nebo raději vůbec.",
  "Občas ti vystoupí otázka: Jakým mužem vlastně jsem?",
];

export const Problem = () => (
  <section id="o-knize" className="bg-cream py-28 text-navy-deep sm:py-36" data-testid="problem-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-bronze">
            <span className="h-px w-10 bg-bronze/60" aria-hidden="true" />
            Poznáš se v tom?
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            Možná nepotřebuješ další rady.
            <br />
            <span className="italic text-bronze">Potřebuješ jasno.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-navy-deep/70 sm:text-lg">
            Osobního rozvoje je všude plno. Motivační citáty, rychlé návody, cizí recepty na
            úspěch. Jenže problém většiny mužů není nedostatek informací — ale absence vlastního
            rámce, podle kterého se rozhodovat.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-x-16 gap-y-2 md:grid-cols-2">
        {SIGNALS.map((s, i) => (
          <Reveal key={s} delay={0.05 * (i % 4)}>
            <div className="flex items-start gap-5 border-b border-navy-deep/10 py-6">
              <span className="mt-1 font-serif text-lg italic text-bronze/70">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-base leading-relaxed text-navy-deep/85 sm:text-lg">{s}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-14 max-w-2xl font-serif text-xl italic leading-snug text-navy-deep/80 sm:text-2xl">
          „Žádný z těchhle pocitů neznamená, že je s tebou něco špatně. Znamenají jen, že ti
          chybí jasný rámec, podle kterého se rozhodovat.“
        </p>
      </Reveal>
    </div>
  </section>
);
